import { render, staticRenderFns } from "./ABMMotivos.vue?vue&type=template&id=04006469&"
import script from "./ABMMotivos.vue?vue&type=script&lang=js&"
export * from "./ABMMotivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports